module.exports = {
	"name": "Mona Bärenfänger",
	"age": 30,
	"location": "Berlin",
	"linkedin": "https://www.linkedin.com/in/mona-b-037196152/",
	"github": "https://github.com/Tschakki",
	"twitter": "https://twitter.com/monabaer"
};


//////////////////
// WEBPACK FOOTER
// ./src/profile.json
// module id = 343
// module chunks = 0